import { render, staticRenderFns } from "./SatellitesOnboarding.vue?vue&type=template&id=1fa1d832&scoped=true"
import script from "./SatellitesOnboarding.vue?vue&type=script&lang=js"
export * from "./SatellitesOnboarding.vue?vue&type=script&lang=js"
import style0 from "./SatellitesOnboarding.vue?vue&type=style&index=0&id=1fa1d832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa1d832",
  null
  
)

export default component.exports